import { useGetInvoiceConfigId, useGetMetadataOfFile } from 'src/use-cases/internalDashboard/useFileResolution';
import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { RhfMuiNumericField, RhfMuiSelect } from '../../molecules/fields/rhf-mui-fields';
import { useFieldMaterialUIStyles } from '../../molecules/fields/useFieldMaterialUIStyles';
import { useInternalDashboardSelector } from './Selector';

export const FormEditConfig = () => {
  const { classes } = useFieldMaterialUIStyles();
  const { setValue } = useFormContext();
  const { selectedRow } = useInternalDashboardSelector();

  const { data, isLoading } = useGetInvoiceConfigId();
  const { data: metadata, isLoading: isLoadingMetadata } = useGetMetadataOfFile(selectedRow?.invoiceFileProcessingId);
  useEffect(() => {
    if (metadata?.['config-id']) {
      setValue('configId', metadata?.['config-id'] || '');
    } else {
      setValue('configId', '');
    }
    if (metadata?.['no-invoice-pages']) {
      setValue('extractedPage', metadata?.['no-invoice-pages'] || '');
    } else {
      setValue('extractedPage', '');
    }
  }, [metadata, setValue]);

  const configIdOptions = useMemo(() => {
    if (data && data?.length > 0) {
      return data.map((name) => ({
        id: name,
        label: name,
      }));
    }
    return [];
  }, [data]);

  return (
    <>
      <div className='mt-4'>
        <RhfMuiSelect
          name='configId'
          className={classes.inputField}
          fullWidth
          sx={{ color: '#dddddd' }}
          label='Config Id'
          hideFieldLabel
          disabled={isLoading || isLoadingMetadata}
          options={configIdOptions}
        />
      </div>
      <div className='mt-16'>
        <RhfMuiNumericField name='extractedPage' label='Number of Pages to Extract' hideFieldLabel />
      </div>
    </>
  );
};
